export const timezones = [
  { value: 'Asia/Kolkata', label: 'India (IST - GMT+5:30)' },
  { value: 'America/New_York', label: 'New York (EST - GMT-5)' },
  { value: 'America/Los_Angeles', label: 'Los Angeles (PST - GMT-8)' },
  { value: 'Europe/London', label: 'London (GMT)' },
  { value: 'Europe/Paris', label: 'Paris (CET - GMT+1)' },
  { value: 'Asia/Dubai', label: 'Dubai (GST - GMT+4)' },
  { value: 'Asia/Singapore', label: 'Singapore (SGT - GMT+8)' },
  { value: 'Australia/Sydney', label: 'Sydney (AEDT - GMT+11)' },
  { value: 'Asia/Tokyo', label: 'Tokyo (JST - GMT+9)' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT - GMT+8)' }
];
